module.exports = __webpack_public_path__ + "media/images/bruntwork-ac8d2b7fcbfb7f6edf7b516a89ae181e.png";